module.exports = __webpack_public_path__ + "static/media/arena_completed.57d54f49.mp3";